export default __webpack_public_path__ + "static/media/Dashboards_DXC_Logo.e5a91031.png";